import { useQueryClient } from '@tanstack/react-query';
import { useNotification } from 'hooks/notification/useNotification';
import { useSignalR } from 'hooks/useSiglanR';
import { useSignalREvent } from 'hooks/useSignalREvent';
import { useStoreState } from 'providers/StoreStateContext';
import { useEffect, useRef } from 'react';
import { IChatEvents } from './types';

export const useChatConnection = () => {
  const { token } = useStoreState();

  const { connection } = useSignalR('messages');

  const notification = useNotification();

  const queryClient = useQueryClient();

  const connectionRef = useRef({
    token,
  });

  useEffect(() => {
    connectionRef.current.token = token;
  }, [token]);

  useSignalREvent<IChatEvents, 'SendMessage'>(connection, 'SendMessage', async (message) => {
    await queryClient.invalidateQueries({
      queryKey: ['messages-list', { messageThreadId: message.messageThreadId }],
    });
    await queryClient.invalidateQueries({
      queryKey: ['chats-list'],
    });

    await queryClient.refetchQueries({
      queryKey: ['chat-unread-count'],
    });

    notification.message(message);
  });

  useSignalREvent<IChatEvents, 'ReadMessage'>(connection, 'ReadMessage', async (message) => {
    await queryClient.invalidateQueries({
      queryKey: ['messages-list', { messageThreadId: message.messageThreadId }],
    });
    await queryClient.invalidateQueries({
      queryKey: ['chats-list'],
    });

    await queryClient.refetchQueries({
      queryKey: ['chat-unread-count'],
    });
  });
  useSignalREvent<IChatEvents, 'CloseThread'>(connection, 'CloseThread', async (message) => {
    await queryClient.invalidateQueries({
      queryKey: ['chats-list'],
    });
    await queryClient.invalidateQueries({
      queryKey: ['messages-list', { messageThreadId: message.messageThreadId }],
    });

    await queryClient.refetchQueries({
      queryKey: ['chat-unread-count'],
    });
  });

  return connection;
};
